import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { StatusBadge } from "@/components/StatusBadge";
import { api, formatDateTimeBR } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

function List({ docs }) {
  if (docs.length === 0) return <div className="text-sm text-slate-500 py-6 text-center">Nenhum documento.</div>;
  return (
    <div className="space-y-3">
      {docs.map((d) => (
        <Link
          key={d.id}
          to={`/documentos/${d.id}`}
          className="block p-4 border border-slate-200 rounded-lg hover:bg-slate-50"
          data-testid={`reviews-doc-${d.id}`}
        >
          <div className="flex items-start justify-between gap-3 flex-wrap">
            <div>
              <div className="flex items-center gap-2 flex-wrap">
                <FileText className="w-4 h-4 text-slate-500" />
                <span className="font-medium text-slate-900">{d.title}</span>
                <StatusBadge status={d.status} />
                <span className="text-xs text-slate-500">v{d.current_version}</span>
              </div>
              <div className="text-xs text-slate-500 mt-1">
                Submetido por {d.created_by_name} em {formatDateTimeBR(d.updated_at)}
              </div>
            </div>
            <ArrowRight className="w-4 h-4 text-slate-400 mt-1" />
          </div>
        </Link>
      ))}
    </div>
  );
}

export default function Reviews() {
  const [pending, setPending] = useState(null);
  const [recent, setRecent] = useState(null);

  useEffect(() => {
    api.get("/documents", { params: { status_filter: "pending_legal" } }).then(({ data }) => setPending(data));
    api.get("/documents").then(({ data }) => setRecent(data));
  }, []);

  if (!pending || !recent) return <Skeleton className="h-96" />;

  const reviewed = recent.filter(d => d.status !== "pending_legal" && d.status !== "draft");

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">Fila de Revisões</h1>
        <p className="text-sm text-slate-600 mt-1">
          Analise documentos antes do envio para a Diretora.
        </p>
      </div>

      <Tabs defaultValue="pending">
        <TabsList>
          <TabsTrigger value="pending">Aguardando ({pending.length})</TabsTrigger>
          <TabsTrigger value="reviewed">Revisados ({reviewed.length})</TabsTrigger>
        </TabsList>
        <TabsContent value="pending">
          <Card className="card-soft">
            <CardContent className="pt-6">
              <List docs={pending} />
            </CardContent>
          </Card>
        </TabsContent>
        <TabsContent value="reviewed">
          <Card className="card-soft">
            <CardContent className="pt-6">
              <List docs={reviewed} />
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
